import { ApiTokenRequestStatus } from '../types';

export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_SORT = 'id,desc';

export const TOKEN_REQUEST_CREATED_SORT = 'createdDate,desc';
export const TOKEN_REQUEST_ISSUED_SORT = 'updatedDate,desc';

export const API_TOKEN_REQUEST_STATUS_LABELS: Record<
    ApiTokenRequestStatus,
    string
> = {
    NEW: 'Новая',
    IN_REVIEW: 'В обработке',
    APPROVED: 'Согласована',
    REJECTED: 'Отказано',
    TOKEN_ISSUED: 'Токен выдан',
};

export const API_TOKEN_REQUEST_STATUS_COLORS: Record<
    ApiTokenRequestStatus,
    string
> = {
    NEW: 'blue',
    IN_REVIEW: 'orange',
    APPROVED: 'green',
    REJECTED: 'red',
    TOKEN_ISSUED: 'purple',
};

export const EDITABLE_API_TOKEN_REQUEST_STATUSES: Array<
    Exclude<ApiTokenRequestStatus, 'TOKEN_ISSUED'>
> = ['NEW', 'IN_REVIEW', 'APPROVED', 'REJECTED'];